import { useSearchParams } from "react-router-dom";

const LogoutView = () => {
    const [searchParams] = useSearchParams();
    window.location.replace(searchParams.get("state") || "");
    return null;
};

export default LogoutView;
